<template>
   <div class="user" :style="{ minHeight: height + 'px' }">
        <a-tabs default-active-key="1">
            <a-tab-pane key="1">
                <span slot="tab">
                   企业信息认证
                </span>
                <company ref="company"></company>
            </a-tab-pane>
            <a-tab-pane key="2">
                <span slot="tab">
                    个人信息认证
                </span>
                <personal ref="personal"></personal>
            </a-tab-pane>
        </a-tabs>
   </div>    
</template>
<script>
import personal from './personal.vue'
import company from './company.vue'
export default { 
  components:{
      personal,
      company
  },  
  data(){
      return{
         height:''
      }
  },
  mounted(){
       this.height = document.body.clientHeight - 85;
       this.$parent.current = '1';
   },
}
</script>

<style lang="less" scoped>
.user{
    width: 1300px;
    margin:0 auto;
    background: #fff;
}
</style>